import { IPcrSummary } from '../features/home/store/home.types'
import { IPcr } from '../features/pcr/store/pcr.types'

export const buildPcrSummary = (pcr: IPcr): IPcrSummary => {
  return {
    agencyName: pcr.agencyName,
    agencyNumber: pcr.agencyNumber,
    callNature: pcr.patient?.tripInformation?.patientCategory?.name || '',
    createdBy: pcr.createdBy,
    createDateTime: pcr.createDateTime,
    crew: pcr.crew,
    date: pcr.times?.dispatchedDate,
    patientName: `${pcr.patient?.patientDemographics?.firstName || ''} ${
      pcr.patient?.patientDemographics?.lastName || ''
    }`,
    pcrId: pcr.pcrId,
    prid: pcr.prid,
    pickupLocation: pcr.patient?.pickupAddress?.addressLine1 || '',
    serviceId: pcr.serviceId,
    status: pcr.status,
    time: pcr.times?.dispatchedTime,
    timeZoneOffset: pcr.timeZoneOffset,
    unit: pcr.patient?.tripInformation?.unit?.name || '',
    base: pcr.patient?.tripInformation?.base?.name || '',
    version: pcr.version,
    isChartLockedIn: pcr.completeChart?.lockChart || 0,
    lastAutoUploadDateTime: pcr.submitChart?.lastAutoUploadDateTime || null,
    signerDetails: pcr.signerDetails,
    sourceInfo: pcr.sourceInfo,
  }
}
